{
  "alert": "Avviso",
  "dismiss": "Ignora"
}
